import styled from 'styled-components'
import Flex from '../Flex/Flex'

const Fieldset = styled(Flex).attrs({
  as: 'fieldset',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
})`
  width: 100%;
  min-width: 100px;
  appearance: none;
  border: none;
  padding-block-start: 0;
  padding-inline-start: 0;
  padding-inline-end: 0;
  padding-block-end: 0;
  margin-inline-start: 0;
  margin-inline-end: 0;
`

export default Fieldset
